// src/components/AccountInfo.jsx
import React from 'react';

import './account-info.css';

const AccountInfo = ({ account, isLoading, onRefresh, onConnect }) => {
  return (
    <div className="account-section justify-between items-center p-4 rounded-lg">
      <p className="text-lg mb-3 text-black font-bold">Connected Account (wallet)</p>
      <div className="flex sm:flex-row gap-4">
          {account ? (
            // If account is connected, show the account address and Refresh button
            <>
              <p className="font-mono text-gray-800 font-medium p-2 pl-4 pr-4 rounded-md bg-gray-200">{account}</p>
              <button
                onClick={onRefresh}
                disabled={isLoading}
                className={`
                  px-4 py-2 bg-blue-500 text-white rounded-lg font-medium hover:bg-blue-600
                  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition
                  ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}
                `}
              >
                {isLoading ? 'Refreshing...' : 'Refresh Data'}
              </button>
            </>
          ) : (
            // If no account is connected, show Connect Wallet button
            <button
              onClick={onConnect}
              disabled={isLoading}
              className={`
                px-4 py-2 bg-blue-500 text-white rounded-lg font-medium hover:bg-blue-600
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition
                ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}
              `}
            >
              {isLoading ? 'Connecting...' : 'Connect Wallet'}
            </button>
          )}
      </div>
    </div>
  );
};

export default AccountInfo;